/**
 * Chrome component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { EuiButton, EuiCallOut, EuiPage, EuiPageBody, EuiSpacer } from '@elastic/eui';

import Headers from './headers';
import { navigate } from 'gatsby-link';
import '../../themes/theme_light.scss';
import { useStore } from '../../stores';
export const ThemeContext = React.createContext('dark');

//Catches render errors anywhere in the app and shows them instead of white-screening.
//Without this, a render crash unmounts the tree and errors are invisible.
class ErrorBoundary extends React.Component<{ children?: React.ReactNode }, { error: Error | null }> {
    constructor(props: { children?: React.ReactNode }) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error: Error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <EuiPage restrictWidth>
                    <EuiPageBody>
                        <EuiSpacer />
                        <EuiCallOut title="Something went wrong on this page" color="danger" iconType="alert">
                            <p>{this.state.error.message}</p>
                            <EuiButton color="danger" onClick={() => (window.location.href = '/home')}>
                                Back to home
                            </EuiButton>
                        </EuiCallOut>
                    </EuiPageBody>
                </EuiPage>
            );
        }
        return this.props.children;
    }
}

export const Chrome = ({ children }: any) => {
    const initialTheme = 'light';
    const [themeIsLoading, setThemeIsLoading] = useState(false);
    const [theme, setTheme] = useState(initialTheme);
    const location = window.location.pathname;
    const {
        userStore: { isLoggedIn },
    } = useStore();

    document.body.classList.add('euiBody--headerIsFixed--double');

    useEffect(() => {
        // TODO: Move below authentication checks to Gatsby private route
        if (!isLoggedIn) {
            navigate('/', {
                state: { callbackUrl: location },
            });
        }
        //NOTE: this effect previously had a cleanup that called window.location.reload() on unmount
        //(leftover from theme switching). Combined with a render error it caused an infinite
        //reload loop, since React unmounts the tree when a component throws. Removed.
        localStorage.setItem('theme', theme);
    }, [theme]);

    return (
        <ThemeContext.Provider value={theme}>
            <div>
                <EuiSpacer size="xs" />
                <Headers />
                <ErrorBoundary>{children}</ErrorBoundary>
            </div>
        </ThemeContext.Provider>
    );
};
